import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["collapse", "link"]

  connect() {
    this.expandActiveSection()
  }

  expandActiveSection() {
    const currentPath = window.location.pathname
    let bestMatch = null
    let bestMatchScore = 0

    // 全リンクをチェックして最適なマッチを見つける
    this.linkTargets.forEach(link => {
      const score = this.linkMatchScore(currentPath, link)
      if (score > bestMatchScore) {
        bestMatchScore = score
        bestMatch = link
      }
    })

    // マッチしたリンクがあれば、そのセクションを展開
    if (bestMatch && bestMatchScore > 0) {
      this.expandCollapseForLink(bestMatch)
      this.markActiveLink(bestMatch)
    }
  }

  // リンクの点数。href に加えて data-sidebar-extra-paths(空白区切り)のパスも採点し、いちばん高い点を使う。
  // サイドバーにリンクの無い画面(例: /agent_detection_settings)を、関連するリンク(SNS分析エージェント)でハイライトするため
  linkMatchScore(currentPath, link) {
    const href = link.getAttribute('href')
    if (!href) return 0

    const extraPaths = (link.getAttribute('data-sidebar-extra-paths') || '').split(/\s+/).filter(p => p.length > 0)
    return Math.max(...[href, ...extraPaths].map(path => this.calculateMatchScore(currentPath, path)))
  }

  calculateMatchScore(currentPath, linkPath) {
    // 完全一致の場合は最高スコア
    if (currentPath === linkPath) {
      return 1000
    }

    // 先頭一致の場合、一致する長さをスコアとする
    if (currentPath.startsWith(linkPath) && linkPath !== '/') {
      return linkPath.length
    }

    // パスセグメントでの部分一致をチェック
    const currentSegments = currentPath.split('/').filter(s => s.length > 0)
    const linkSegments = linkPath.split('/').filter(s => s.length > 0)

    let matchingSegments = 0
    for (let i = 0; i < Math.min(currentSegments.length, linkSegments.length); i++) {
      if (currentSegments[i] === linkSegments[i]) {
        matchingSegments++
      } else {
        break
      }
    }

    return matchingSegments > 0 ? matchingSegments : 0
  }

  expandCollapseForLink(link) {
    // リンクの親要素をたどってcollapseを見つけて展開
    let element = link.parentElement
    while (element && element !== this.element) {
      if (element.classList.contains('collapse')) {
        const checkbox = element.querySelector('input[type="checkbox"]')
        if (checkbox) {
          checkbox.checked = true
        }
      }
      element = element.parentElement
    }
  }

  markActiveLink(link) {
    // 既存のactiveクラスを削除
    this.linkTargets.forEach(l => l.classList.remove('active'))
    // マッチしたリンクにactiveクラスを追加
    link.classList.add('active')
  }
}